import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ReactionSurpriseIcon = (props: IconProps) => (
  <Icon width="32px" height="32px" viewBox="0 0 32 32" {...props}>
    <circle cx="16" cy="16" r="16" fill="#FFEACC" />
    <path
      fill="#5B5B5B"
      fillRule="evenodd"
      d="M26.667 9.866c0 1.77-1.43 3.2-3.2 3.2-1.771 0-3.2-1.43-3.2-3.2 0-1.77 1.429-3.2 3.2-3.2 1.77 0 3.2 1.43 3.2 3.2Zm-14.934 0c0 1.77-1.429 3.2-3.2 3.2-1.77 0-3.2-1.43-3.2-3.2 0-1.77 1.43-3.2 3.2-3.2 1.771 0 3.2 1.43 3.2 3.2ZM16 27.999c2.357 0 4.267-2.387 4.267-5.333 0-2.945-1.91-5.333-4.267-5.333-2.356 0-4.267 2.388-4.267 5.333 0 2.945 1.91 5.333 4.267 5.333Z"
      clipRule="evenodd"
    />
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M5.333 6.666h21.333v21.333H5.333z" />
      </clipPath>
    </defs>
  </Icon>
);

export default memo(ReactionSurpriseIcon);
